module.exports = __webpack_public_path__ + "ec6ff3a24c62b6d54d175d9f4438ddde.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/images/icon-colorful/Hang_Dac_San.svg
// module id = ./assets/images/icon-colorful/Hang_Dac_San.svg
// module chunks = 0